import LawsDaqAxios from "./lawsdaqAxios";
import { APIError } from "./apiError";

const lawsDaqAxios = new LawsDaqAxios();

type APIErrorCallback = (error: APIError) => void;

export { APIError, APIErrorCallback };
export default lawsDaqAxios;
